<template>
  <div v-if="object">
    <div class="row text-white" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{warning ? warning : object.id != 0 ? object.baseTSR.name + ' - ' + object.disabledCategory.name : 'Новая компенсация'}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div v-if="object.id === 0" class="row">
      <div class="col-md-6">
        <items-option :label="'Базовое ТСР'" :object="object.baseTSR" @update="setBaseTSR" :type="'base_tsr'">
        </items-option>
      </div>
      <div class="col-md-6">
        <items-option :label="'Категория инвалидности'" :object="object.disabledCategory" @update="setDC" :type="'disabledCategory'">
        </items-option>
      </div>
    </div>

    <div class="table-responsive text-left">
      <table class="table bg-white">
        <thead>
        <tr>
          <slot name="columns">
            <th> Начало действия </th>
            <th> Сумма </th>
          </slot>
        </tr>
        </thead>
        <tbody v-if="object.limit">
        <tr>
          <td>
            <base-input v-model="historyTag.startDate"
                        :value="historyTag.startDate"
                        :date="true"
            ></base-input>
          </td>
          <td>
            <base-input v-model="historyTag.value"
                        :value="historyTag.value"
                        :number="true"
                        :placeholder="'сумма'">
            </base-input>
          </td>
        </tr>
        <tr v-for="(item, index) in object.limit" :key="index">
          <td>
            {{itemValue(item, 'startDate')}}
          </td>
          <td>
            {{itemValue(item, 'value')}}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {getValueByField, longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       object: null,
       warning: null,
       historyTag: {value: 0},
       inSave: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       if (this.object.baseTSR && this.object.disabledCategory
           && this.historyTag.value > 0 && this.historyTag.startDate > 0) {
         this.inSave = true;
         try {
           this.object.limit.push(this.historyTag);
           let renewed = await this.$repo.save(this.object, this.type);
           if (renewed) {
             this.item.object = renewed;
             this.item.id = renewed.id;
             this.object = JSON.parse(JSON.stringify(renewed));
             this.historyTag = {value: 0, startDate: null};
             this.warning = null;
             this.inSave = false;
             this.toView();
           }
         } catch(error) {
           this.inSave = false;
         }
       } else {
         this.warning = 'НУЖНО ЗАПОЛНИТЬ ВСЕ ПОЛЯ!!!'
       }
     },
     itemValue(item, column) {
       let value = this.getValue(item, column);
       if (value) {
         if (column.toLowerCase().includes("date") || column.toLowerCase().includes("time")) {
           return longAsStringDate(value);
         } else {
           return value;
         }
       } else {
         return "-"
       }
     },
     getValue(item, column) {
       return item ? getValueByField(item, column) : '-';
     },
     setBaseTSR(value) {
       this.object.baseTSR = value;
     },
     setDC(value) {
       this.object.disabledCategory = value;
     }
   },
   mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
   }
 }
</script>
